import { IPublishRulesEntry } from 'APIPackage/PublishRulesModule/interfaces/IPublishRulesEntry';
import { IKnmStatusSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmStatusSelectOption';
import { IKnmReasonTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmReasonTypeSelectOption';

import { dateRegexp } from '../constants/publishRulesDateRegexp';

export const makePlannedValues = (
  values: IPublishRulesEntry,
  reasonTypesSelectOptions: IKnmReasonTypeSelectOption[],
  knmStatusesSelectOptions?: IKnmStatusSelectOption[],
) => ({
  ...(values?.settings?.mainRule?.passportStatusCodes
    ? {
        uponAttainingStatus: knmStatusesSelectOptions?.filter(item =>
          values?.settings?.mainRule?.passportStatusCodes?.includes(item.code),
        ),
      }
    : {}),
  publicationDate: dateRegexp.test(values?.settings?.mainRule.publicationMode || '')
    ? values?.settings?.mainRule.publicationMode
    : undefined,
  additionalSettings:
    values?.settings?.additionalRules?.map(rule => ({
      typeOfBasis: reasonTypesSelectOptions?.find(item => item.id === rule.reasonTypeId),
      publicationDate: dateRegexp.test(rule.rule?.publicationMode || '') ? rule.rule?.publicationMode : undefined,
      ...(rule?.rule?.passportStatusCodes
        ? {
            uponAttainingStatus: knmStatusesSelectOptions?.filter(item =>
              rule?.rule?.passportStatusCodes?.includes(item.code),
            ),
          }
        : {}),
    })) || [],
});
